import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import CheckboxField from 'components/form/checkbox'
import './promoted-only-checkbox.css'

const PromotedOnlyCheckboxInput = ({ input, meta, disabled }) =>
  <div className='br-promoted-only-checkbox'>
    <div className='br-promoted-only-container'>
      <CheckboxField
        className='icheckbox_square'
        label='isPromotedTweet'
        tooltipTitle='Send as promoted-only'
        input={input}
        meta={meta}
        disabled={disabled}
      />
    </div>
  </div>

PromotedOnlyCheckboxInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  disabled: PropTypes.bool
}

const PromotedOnlyCheckboxField = ({ name, disabled = true }) =>
  <Field
    name={`${name}.isPromotedTweet`}
    disabled={disabled}
    component={PromotedOnlyCheckboxInput}
  />

PromotedOnlyCheckboxField.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool
}

export default PromotedOnlyCheckboxField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/promoted-only-checkbox/index.js